import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../../services/redux/types";

export const selectModelsState = (state: RootState) => state.modelsState;

export const selectAllModels = createSelector(
  selectModelsState,
  (state) => state.models,
);

export const selectSelectedModel = createSelector(
  selectModelsState,
  (state) => state.selectedModel,
);

export const selectIsModelLoaded = createSelector(
  selectModelsState,
  (state) => state.isLoading,
);

export const selectAllSelectedModels = createSelector(
  selectModelsState,
  (state) => state.selectedModel,
);
